app.factory('indexService', [ '$http','$rootScope', function($http, $rootScope) {
    return {
        signOut : function(){
            $rootScope.$broadcast('event:postSignOut')
            // $http.get('/api/signout')
            // .then(result => {
            // })
        }
    };
} ]);
